import styled from 'styled-components';

export const Wrap = styled.div`
  max-width: 980px;
  margin: 18px auto 26px;
  padding: 0 18px;
`;

export const Card = styled.div`
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  background: #ffffff;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
  padding: 22px 22px 18px;
`;

export const Title = styled.h1`
  font-size: 22px;
  text-align: center;
  margin: 0 0 14px;
  font-weight: 800;
  color: #111;
`;

export const SubTitle = styled.p`
  font-size: 18px;
  text-align: center;
  margin: 0;
  font-weight: 700;
  color: #111;
`;

export const Hint = styled.p`
  font-size: 16px;
  text-align: center;
  color: #4a4a4a;
  margin: 6px 0 18px;

  b {
    font-weight: 800;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 18px;

  @media (max-width: 640px) {
    font-size: 12px;
  }
`;

export const THead = styled.thead`
  th {
    font-size: 18px;
    font-weight: 800;
    text-align: left;
    padding: 10px 12px;
    border-bottom: 1px solid #e6e6e6;
    @media (max-width: 640px) {
       padding: 8px;
       font-size: 14px;
      }
  }

  th:nth-child(1) {
    width: 52px;
    @media (max-width: 640px) {
        width: 30px;
        font-size: 12px;
      }
  }

  th:nth-child(2) {
    width: 36%;
    @media (max-width: 640px) {
        width: 20%;
        font-size: 12px;
      }
  }

  th:nth-child(3) {
    width: 120px;
    text-align: center;
    @media (max-width: 640px) {
        width: 20px;
      }
  }

  th:nth-child(4) {
    text-align: center;
  }
`;

export const TBody = styled.tbody`
  tr {
    border-bottom: 1px solid #e6e6e6;
  }

  tr:nth-child(odd) {
    background: #f3f3f3;
  }

  tr:nth-child(even) {
    background: #ffffff;
  }
`;

export const TableRow = styled.tr`
  opacity: ${(props) => (props.disabled ? 0.55 : 1)};
  transition: opacity 0.15s ease;
`;

export const TableCell = styled.td`
  padding: 10px;
  vertical-align: middle;

  &:nth-child(1) {
    @media (max-width: 640px) {
      padding-right: 2px;
    }
  }

  &:nth-child(2) {
    @media (max-width: 640px) {
      padding-right: 2px;
    }
  }

  &:nth-child(3),
  &:nth-child(4) {
    text-align: center;
  }
`;

export const ProductName = styled.span`
  font-weight: 800;
  @media (max-width: 640px) {
      font-size: 11px;
    }
`;

export const Kwh = styled.span`
  font-weight: 800;
`;

export const Gift = styled.span`
  b {
    font-weight: 900;
  }
`;

export const CheckboxWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  width: 22px;
  height: 22px;
  margin: 0;
  accent-color: rgb(255, 43, 110);
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`;

export const FootNote = styled.div`
  margin-top: 14px;
  font-size: 14px;
  color: #222;

  p {
    font-style: italic;
  }
`;

export const CtaWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 18px;
`;

export const ConfirmButton = styled.button`
  border: 0;
  border-radius: 10px;
  padding: 14px 28px;
  font-weight: 900;
  cursor: pointer;
  background: rgb(255, 43, 110);
  color: #fff;
  letter-spacing: 0.5px;
  min-width: 220px;
  font-size: 16px;

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }

  @media (max-width: 640px) {
    width: 100%;
    min-width: unset;
  }
`;
